import { colors } from '../../../../../enums/colors';
import i18n from "i18next";
import {
    IconForkKnifeCard,
    IconDashedCurrencyCard,
    IconPortfolioCard,
    IconCircleCurrencyCard, IconStarCard, IconDownArrowCard, IconBarGraphCard
} from "../../../../../components/buttons/IconButtons";
import { currencyFormat } from "../../../../../Apis/functions";
import {ATTENDANCE_STATUS_COLOR_MODEL, TYPE_MODEL_COLOR_MODEL} from "../../../Company/Payroll/Model/Model";

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @type {{inTime: string, toAddEdit: (function(): {inTime: MODEL_COLOR.inTime, inMealTime: MODEL_COLOR.inMealTime, outOfMealTime: MODEL_COLOR.outOfMealTime, id: MODEL_COLOR.id, outOfTime: MODEL_COLOR.outOfTime}), inMealTime: string, isValid: (function()), outOfMealTime: string, id: null, outOfTime: string}}
 */
export const COST_TYPE_NAME = 'costType';
export const IS_MEAL_TIME_COST_NAME = 'isMealTimeCost';
export const IS_BASE_COST_NAME = 'isBaseCost';
export const IS_CATALOGUE_COST_NAME = 'isCatalogueCost';
export const BASE_COST_NAME = 'baseCost';

export const MODEL_COLOR = {
    id: null,
    inTime: colors.secondary500,
    outOfTime: colors.errorCode700,
    inMealTime: colors.success500,
    outOfMealTime: colors.warning500,
    type : "MODEL_COLOR",

    isValid: function () {
        return this.inTime !== ''
            && this.outOfTime !== ''
            && this.inMealTime !== ''
            && this.outOfMealTime !== '';
    },
    toAddEdit: function () {
        return {
            id: this.id,
            inTime: this.inTime,
            outOfTime: this.outOfTime,
            inMealTime: this.inMealTime,
            outOfMealTime: this.outOfMealTime,
        }
    }
}

export const MODE_TYPE_MODEL = [
    { id: 1, name: 'none' },
    { id: 2, name: 'soft' },
    { id: 3, name: 'hard' },
]

export const MIN_MAX_VALUES_MANAGE = {
    MEALTIME: { start: 1, end: 120 },
    FOOD_PER_DAY: { start: 1, end: 4 },
}

export const FOODIE_SETTING_MODEL = {
    id: null,
    baseCost: null,
    subsidy: null,
    securityModeId: null,
    accessModeId: null,
    isBaseCost: false,
    isMealTimeCost: false,
    isExtraMealSubsidy: false,
    extraMealSubsidy: null,
    selectionMenuDelay: null,
    recordTimeout:1,
    isValid: function () {
        const baseCostValid = this.isBaseCost
            ? this.baseCost != null && this.baseCost !== ""
            : true;

        const extraMealSubsidyValid = this.isExtraMealSubsidy
            ? this.extraMealSubsidy != null && this.extraMealSubsidy !== ""
            : true;

        return baseCostValid
            && extraMealSubsidyValid
            && (this.subsidy != null && this.subsidy !== "")
            && this.securityModeId != null && this.securityModeId !== ""
            && this.accessModeId != null && this.accessModeId !== ""
            && this.selectionMenuDelay != null && this.selectionMenuDelay !== ""
            && parseInt(this.selectionMenuDelay) > 0;
    },
    set: function (data) {
       return {
           ...this,
           id: data.id,
           baseCost: data.baseCost,
           subsidy: data.subsidy,
           securityModeId: data.securityModeId,
           accessModeId: data.accessModeId,
           isBaseCost: Boolean(data.isBaseCost),
           isMealTimeCost:  Boolean(data.isMealTimeCost),
           isExtraMealSubsidy: Boolean(data.isExtraMealSubsidy),
           extraMealSubsidy:  data.extraMealSubsidy,
           selectionMenuDelay: data.selectionMenuDelay,
           recordTimeout: data.recordTimeout
       }
    },

    toAddEdit: function () {
        return {
            id: this.id,
            baseCost: this.baseCost,
            subsidy: this.subsidy,
            securityModeId: this.securityModeId,
            accessModeId: this.accessModeId,
            isBaseCost: this.isBaseCost,
            isMealTimeCost: this.isMealTimeCost,
            isExtraMealSubsidy: this.isExtraMealSubsidy,
            extraMealSubsidy: this.extraMealSubsidy,
            selectionMenuDelay: this.selectionMenuDelay,
            recordTimeout: this.recordTimeout
        }
    },
}

export const FOODIE_DEPARTMENT = {
    id: null,
    startShiftAt: '',
    endShiftAt: '',
    foodsPerDay: null,
    mealTime: null,
    departmentId: null,
    isValid: function () {
        return this.startShiftAt != ''
            && this.startShiftAt != null
            && this.endShiftAt != ''
            && this.endShiftAt != null
            && this.mealTime != null
            && this.foodsPerDay != null
            && this.validateFoodsPerDay()
            && this.validateMealTime();
    },
    toAddEdit: function () {
        return {
            id: this.id,
            startShiftAt: this.startShiftAt,
            endShiftAt: this.endShiftAt,
            mealTime: this.mealTime,
            foodsPerDay: this.foodsPerDay,
            departmentId: this.departmentId,
        }
    },
    validateMealTime: function () {
        if (this.mealTime === null || this.mealTime === undefined)
            return true; //valid until user provides a value
        const value = Number(this.mealTime);
        return !isNaN(value) && value >= MIN_MAX_VALUES_MANAGE.MEALTIME.start && value <= MIN_MAX_VALUES_MANAGE.MEALTIME.end;
    },
    validateFoodsPerDay: function () {
        if (this.foodsPerDay === null || this.foodsPerDay === undefined)
            return true; //valid until user provides a value
        const value = Number(this.foodsPerDay);
        return !isNaN(value) && value >= MIN_MAX_VALUES_MANAGE.FOOD_PER_DAY.start && value <= MIN_MAX_VALUES_MANAGE.FOOD_PER_DAY.end;
    },

}

export const ATTENDANCE_MODES = {
    daily: 1,
    weekly: 2,
    biweekly: 4,
    monthly: 3,
};

export const ATTENDANCE_MODES_LIST = () => ([
    { id: 1, name: i18n.t("daily") },
    { id: 2, name: i18n.t("weekly") },
    { id: 4, name: i18n.t("biweekly") },
    { id: 3, name: i18n.t("monthly") },
]);

export const MULTIDAYS_MODES = [
    ATTENDANCE_MODES.weekly,
    ATTENDANCE_MODES.biweekly,
    ATTENDANCE_MODES.monthly,
];

export const StatusColorKeys = {
    IN_TIME: 'inTime',
    OUT_OF_TIME: 'outOfTime',
    IN_MEAL_TIME: 'inMealTime',
    OUT_MEAL_TIME: 'outOfMealTime',
};

export const statusColorIds = {
    1: 'inTime',
    2: 'outOfTime',
    3: 'inMealTime',
    4: 'outOfMealTime'
}


/**
 * Returns a background color based on the given status value.
 *
 * This function is used for styling time-related chips, depending on status fields
 * such as `totalTimeStatus`, `exitDateStatus`, or `entryDateStatus`.
 *
 * Status codes and their corresponding keys:
 * - 1 → 'inTime'
 * - 2 → 'outOfTime'
 * - 3 → 'inMealTime'
 * - 4 → 'outOfMealTime'
 *
 * The function attempts to get the color from `colorMap` by key.
 * If the color value in `colorMap` is an empty string (`""`), it falls back to the
 * corresponding value from `MODEL_COLOR`.
 * If `colorMap` does not have the key, it also falls back to `MODEL_COLOR`.
 * If the status is invalid or no matching color is found, it returns `colors.shades100`.
 *
 * @param {number} status - The numeric status from the response (1–4).
 * @param data
 * @param model
 * @param {string} [colorMap.inTime] - Color for status 1 (in schedule).
 * @param {string} [colorMap.outOfTime] - Color for status 2 (out of schedule).
 * @param {string} [colorMap.inMealTime] - Color for status 3 (in meal time).
 * @param {string} [colorMap.outOfMealTime] - Color for status 4 (out of meal time).
 *
 * @returns {string} The resolved color string, prioritizing `colorMap` if defined and non-empty,
 *                   otherwise the corresponding `MODEL_COLOR` value,
 *                   or `colors.shades100` as a last fallback.
 */
export const getAttendanceColorByStatus = (status, data = {}, model, variant = TYPE_MODEL_COLOR_MODEL.BG_COLOR) => {
    const defaultColor = colors.shades200
    const defaultTxtColor = colors.general00;
    const noRecordTxtColor = colors.shades700;

    const baseKey = model?.type === 'MODEL_COLOR'
        ? statusColorIds[status]
        : ATTENDANCE_STATUS_COLOR_MODEL[status];

    if (!status) {
        return variant === TYPE_MODEL_COLOR_MODEL.TXT_COLOR
            ? noRecordTxtColor
            : defaultColor;
    }

    // If status is invalid or baseKey is undefined, fallback:
    if (!baseKey) {
        return variant === TYPE_MODEL_COLOR_MODEL.TXT_COLOR
            ? defaultTxtColor
            : defaultColor;
    }
     if (variant === TYPE_MODEL_COLOR_MODEL.TXT_COLOR) {
        const txtKey = `${baseKey}Txt`;

        if (data?.[txtKey]) return data[txtKey];
        if (model?.[txtKey]) return model[txtKey];
        return defaultTxtColor;
    }
    // If colorMap[baseKey] exists but is an empty string,
    // take value from MODEL_COLOR for that baseKey
    if (data.hasOwnProperty(baseKey)) {
        if (data[baseKey] === '') return model[baseKey] ?? defaultColor;
        return data[baseKey];
    }
    // If colorMap[key] is undefined, fallback:
    return model[baseKey] ?? defaultColor;
}


export const TOTAL_MEALS_COUNT_LIST_MODEL = {
    mealRecords: {
        id:"mealRecords",
        titleTrans: "meal_records",
        moneySymbol: "",
        classCard: "card-success-150-50",
        paddingCard: "pl-sm-0 pr-sm-0 pl-md-0 pr-md-2 pl-xl-0 pr-xl-2",
        fontColor: "font-color-success-600",
        iconColor: "icon-color-success-600",
        value:0,
        Icon: IconForkKnifeCard
    },
    total: {
        id:"total",
        titleTrans: "total",
        moneySymbol: "$",
        classCard: "card-secondary-150-50",
        paddingCard: "pl-sm-0 pr-sm-0 pl-md-2 px-md-2 pl-xl-2 pr-xl-2",
        fontColor: "font-color-secondary-600",
        iconColor: "icon-color-secondary-600",
        value:"$ " + currencyFormat(0),
        Icon: IconCircleCurrencyCard
    },
    subsidy: {
        id:"subsidy",
        titleTrans: "subsidy",
        moneySymbol: "$",
        classCard: "card-accent-400-50",
        paddingCard: "pl-sm-0 pr-sm-0 pl-md-0 pr-md-2 pl-xl-2 pr-xl-2",
        fontColor: "font-color-accent-550",
        iconColor: "icon-color-accent-550",
        value:"$ " + currencyFormat(0),
        Icon: IconPortfolioCard
    },
    remains: {
        id:"remains",
        titleTrans: "remain",
        moneySymbol: "$",
        classCard: "card-primary-400-50",
        paddingCard: "pl-sm-0 pr-sm-0 pl-md-2 pr-md-2 pl-xl-2 pr-xl-0",
        fontColor: "font-color-primary-600",
        iconColor: "icon-color-primary-600",
        value: "$ " + currencyFormat(0),
        Icon: IconDashedCurrencyCard
    },
}

export const TOTAL_MEALS_COUNT_GRID_MODEL = {
    MOST_ORDERED_MENU: {
        keyName:"mostPopularName",//backend key
        keyCount:"mostPopularCount",//backend key
        titleTrans: "most_ordered_menu",
        classCard: "card-warning-150-50",
        paddingCard: "pl-sm-0 pr-sm-0 pl-md-0 pr-md-2 pl-xl-0 pr-xl-2",
        fontColor: "font-color-warning-700",
        iconColor: "icon-color-warning-700",
        name:"",
        total:"0",
        Icon: IconStarCard
    },
    LESS_ORDERED: {
        keyName:"lessPopularName",//backend key
        keyCount:"lessPopularCount",//backend key
        titleTrans: "less_ordered",
        classCard: "card-secondary-150-50",
        paddingCard: "pl-sm-0 pr-sm-0 pl-md-0 pr-md-2 pl-xl-0 pr-xl-2",
        fontColor: "font-color-secondary-600",
        iconColor: "icon-color-secondary-600",
        name:"",
        total:"0",
        Icon: IconDownArrowCard
    },
    TOTAL_MEALS_SERVED: {
        keyName:"",
        keyCount:"totalMealsServed",//backend key
        titleTrans: "total_meals_served",
        classCard: "card-success-150-50",
        paddingCard: "pl-sm-0 pr-sm-0 pl-md-0 pr-md-2 pl-xl-0 pr-xl-2",
        fontColor: "font-color-success-600",
        iconColor: "icon-color-success-600",
        name:"",
        total:"0",
        Icon: IconForkKnifeCard
    },
    BASIC_MEAL: {
        keyName:"",
        keyCount:"totalBasicMeals",//backend key
        titleTrans: "no_of_regular_meals",
        classCard: "card-accent-400-50",
        paddingCard: "pl-sm-0 pr-sm-0 pl-md-0 pr-md-2 pl-xl-0 pr-xl-0",
        fontColor: "font-color-accent-600",
        iconColor: "font-color-accent-600",
        name:"",
        total:"0",
        Icon: IconForkKnifeCard
    },
    EXTRA_MEAL: {
        keyName:"",
        keyCount:"totalExtraMeals", //backend key
        titleTrans: "no_of_extra_meals",
        classCard: "card-primary-400-50",
        paddingCard: "pl-sm-0 pr-sm-0 pl-md-0 pr-md-2 pl-xl-2 pr-xl-0",
        fontColor: "font-color-primary-600",
        iconColor: "icon-color-primary-600",
        name:"",
        total:"0",
        Icon: IconBarGraphCard
    },
}

export const MEAL_CATEGORY = {
    REGULAR: "regular_meal",
    EXTRA: "extra_meal",
    false: "regular_meal",
    true: "extra_meal"
}
